import classNames from 'classnames'
import { ArrowRightIcon } from 'lucide-react'
import { buttonIconClasses } from '~/components/Button'
import { focusRing } from '~/utils/styles'

const classes = {
  footerLinks: 'text-blue-700',
}
const TEXT = {
  connectionErrorTitle: 'Es ist ein Fehler aufgetreten',
  dataProtection: 'Datenschutz',
  imprint: 'Impressum',
  agb: 'AGB',
  knowMoreAboutJoviva: 'Mehr über mein.joviva erfahren',
  registerAsMember: (
    <>
      Du möchtest bei joviva teilnehmen? Hier als Sanitätshaus{' '}
      <a
        href={
          'https://www.sani-aktuell.de/mitglied-werden/#1597322703756-20c8785b-32f5'
        }
        target={'_blank'}
        rel={'noreferrer'}
        className={classNames(
          focusRing,
          'underline-position-under cursor-pointer underline',
        )}
      >
        registrieren.
      </a>
    </>
  ),
}
export const Footer = () => (
  <div className={classNames('mx-auto mt-10 w-4/5 xl:w-2/5')}>
    <div className={'flex flex-col items-center justify-center'}>
      <a
        href={'https://www.joviva.de/mein-joviva'}
        target={'_blank'}
        rel={'noreferrer'}
        className={classNames(
          focusRing,
          'text-body2 flex items-center justify-center font-bold text-blue-700',
        )}
      >
        {TEXT.knowMoreAboutJoviva}
        <ArrowRightIcon
          className={classNames(buttonIconClasses.right, 'h-4 w-4 -rotate-45')}
        />
      </a>
      <p className={classNames(focusRing, 'text-md mt-4')}>
        {TEXT.registerAsMember}
      </p>
    </div>
    <div
      className={classNames(
        'text-body1 border-t-grey-200 mx-auto mt-8 flex w-full justify-center gap-6 border-t-1 py-6',
      )}
    >
      <a
        className={classNames(focusRing, classes.footerLinks)}
        href={'https://www.joviva.de/datenschutz'}
      >
        {TEXT.dataProtection}
      </a>
      <a
        className={classNames(focusRing, classes.footerLinks)}
        href={'https://www.joviva.de/impressum'}
      >
        {TEXT.imprint}
      </a>
      <a
        className={classNames(focusRing, classes.footerLinks)}
        href={'https://www.joviva.de/agb'}
      >
        {TEXT.agb}
      </a>
    </div>
  </div>
)
